import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Anomalies from "./pages/Anomalies";
import AnomalyDetail from "./pages/AnomalyDetail";
import DataSources from "./pages/DataSources";
import Alerts from "./pages/Alerts";
import Settings from "./pages/Settings";
import { getAlerts } from "./lib/api";

function App() {
    const [unreadAlerts, setUnreadAlerts] = useState(0);

    useEffect(() => {
        const loadAlertCount = async () => {
            try {
                const response = await getAlerts(true);
                setUnreadAlerts(response.data.length);
            } catch (error) {
                console.error('Failed to load alert count:', error);
            }
        };

        loadAlertCount();
        const interval = setInterval(loadAlertCount, 30000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="App dark">
            <Toaster 
                position="top-right" 
                toastOptions={{
                    style: {
                        background: 'hsl(220, 20%, 11%)',
                        border: '1px solid hsl(210, 20%, 18%)',
                        color: 'hsl(0, 0%, 100%)'
                    }
                }}
            />
            <BrowserRouter>
                <Layout alertCount={unreadAlerts}>
                    <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/anomalies" element={<Anomalies />} />
                        <Route path="/anomalies/:id" element={<AnomalyDetail />} />
                        <Route path="/data-sources" element={<DataSources />} />
                        <Route path="/alerts" element={<Alerts />} />
                        <Route path="/settings" element={<Settings />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}

export default App;
